import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { drupalLink } from '../Utilities/Drupal-link'
import { imageFile } from '../Utilities/Image-file'
import FramerMotionAnimation from '../Utilities/Animations/FramerMotion'
import { Button } from 'react-bootstrap'
import Cookies from 'universal-cookie';
import { safeName } from '../Utilities/Safe-name'
import IconClose from '../../assets/videoClose.svg'
import IconDismiss from '../../assets/videoDismiss.svg'


function setUpVideo(data) {
  let returnMarkup = ""
  let {
    field_display_title,
    field_set_this_video_to_show_on_,
    link_title,
    link_url,
    field_display_link,
    imageRelPath,
    field_video
  } = ""

  const cookies = new Cookies();

  const handlePromo = (instruct) => {
    if (typeof window === "undefined" || !window.document) {
      // SSR
    } else {
      let promoVideo = document.querySelector("div.promo-video-media")
      let promoBanner = document.querySelector("div.promo-video")

      if(promoBanner && promoVideo) {
        let videoExist = promoVideo.getAttribute("data-video-src");
        let videoTitle = document.getElementById("js-video-title").textContent
        let videoCookieName = 'promo_video_dismiss_' + safeName(videoTitle)

        if(promoBanner.classList.contains("promo-video-collapsed") && instruct == 'open') {
          if(videoExist) {
            // get the youtube id from the drupal URL that is stored in drupal
            // we need to switch from watch to embed
            let videoUrl = promoVideo.getAttribute("data-video-src").split('?v=')[1]
            promoVideo.innerHTML += '<iframe width="420" height="236" src="https://www.youtube.com/embed/'+videoUrl+'?controls=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
            promoBanner.classList.remove("promo-video-collapsed")
          }
        }
        else if(!promoBanner.classList.contains("promo-video-collapsed") && instruct == 'close') {
          // just close the video in a way it can be opened again
          promoBanner.classList.add("promo-video-collapsed")
          promoVideo.innerHTML += ''
        }
        else if(instruct == 'dismiss') {
          // set dismiss cookie and hide this video now and forever (based on the title)
          cookies.set(videoCookieName, 'dismiss', { path: '/' });
          promoBanner.classList.add("promo-video-dismiss")
          promoVideo.innerHTML += ''
        }
      }
    }
  }

  function setupPromo() {
    if (typeof window === "undefined" || !window.document) {
      // SSR
    } else {
      // Setup promo, remove flicker from page load
      let promoBanner = document.querySelector("div.promo-video")
      if(promoBanner) {
        promoBanner.classList.remove("promo-video-setup")
      }
    }
  }
  setTimeout(setupPromo, 3000);

  let dismiss = ''
  let videoSrcEmpty = ''

  data.map(function(node, index) {
    let show = false
    if(node.field_set_this_video_to_show_on_ && node.field_set_this_video_to_show_on_ === true) show = true

    if(show == true) {
      if(node.field_display_title) {
        field_display_title = node.field_display_title
      }

      if(node.field_find_out_more_link) {
        if(node.field_find_out_more_link.title && node.field_find_out_more_link.uri) {
          field_display_link = drupalLink(node.field_find_out_more_link)
        }
      }

      if(node.field_video) {
        field_video = node.field_video
      } else {
        videoSrcEmpty = ' promo-video-empty'
      }

      if(node.relationships) {
        if(node.relationships.field_image) {
          if(node.relationships.field_image.localFile) {
            imageRelPath = imageFile(node.relationships.field_image, field_display_title)
          }
        }
      }

      let cookieName = 'promo_video_dismiss_' + safeName(node.field_display_title)
      if(cookies.get(cookieName)) {
        dismiss = ' promo-video-dismiss'
      }

      returnMarkup = (
        <>
          <div className={'promo-video promo-video-setup promo-video-collapsed' + dismiss + videoSrcEmpty}>
            <FramerMotionAnimation delay={2} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={100} transformYEnd={0}>
              <div className='promo-video-media' data-video-src={field_video} >
              </div>
              <div className='promo-video-banner' onClick={() => handlePromo('open')}>
                <div id="js-video-title" className='promo-video-title'><strong>{field_display_title}</strong></div>
                <div className='promo-video-link' onClick={() => handlePromo('dismiss')}>{field_display_link}</div>
                <div className='promo-video-image'>{imageRelPath}</div>
              </div>
              <div className={'promo-video-close'}>
                <Button id="js-dismiss-video" className="dismiss-btn" onClick={() => handlePromo('dismiss')}>Dismiss <IconDismiss /></Button>
                <Button id="js-close-video" className="close-btn" onClick={() => handlePromo('close')}>Close <IconClose /></Button>
              </div>
            </FramerMotionAnimation>
          </div>
        </>
      )
    }
  })

  return (returnMarkup)
}

const FooterVideo = () => (
  <StaticQuery

    query={graphql`{
  content: allTaxonomyTermSiteWidePromoteAVideo {
    nodes {
      field_display_title
      field_find_out_more_link {
        title
        url
        uri
      }
      field_video
      field_set_this_video_to_show_on_
      relationships {
        field_image {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 400
                height: 350
                quality: 90
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
}`}

    render={data => (
      <>
        {setUpVideo(data.content.nodes)}
      </>
    )}
  />

)

export default FooterVideo
